import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isLoggedIn } from '../services/firebase';
import Loader from '../components/LogoLoader';

const withAuth = Component => args => {
  const history = useHistory();
  const [isCheckingUser, setCheckingUser] = useState(true);
  const checkLoggedUser = async () => {
    setCheckingUser(true);
    const isLogged = await isLoggedIn();
    setCheckingUser(false);
    if (!isLogged) {
      history.push('/?skip=true');
    }
  };

  useEffect(() => {
    checkLoggedUser();
  }, []);

  if (isCheckingUser) {
    return <Loader />;
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...args} />;
};

export default withAuth;
